/**
 * Wallet Analytics (FSD Part 3 3.2.2.10, R042/R043; follow-up #80): six reports
 * on one screen, one tab each.
 *
 * The wiring packet spreads `TREASURY_WALLET_ANALYTICS_ROUTES` into the router and
 * adds the nav item described by `TREASURY_WALLET_ANALYTICS_NAV` to section s-3.2.2.
 *
 * Gated on `treasury.wallet.read`, what five of the six report routes declare; the
 * loads-in-transit tab additionally needs `treasury.wallet.funding.read` and is
 * hidden without it. The path is a literal string.
 */

import type { RouteRecordRaw } from 'vue-router'

import { WALLET_ANALYTICS_PERMISSIONS } from '@/modules/treasury/reports/wallet-analytics/permissions'

export const TREASURY_WALLET_ANALYTICS_PATH = '/treasury/reports/wallet-analytics'

/** For the wiring packet: the nav item to add (p03-treasury.ts, s-3.2.2). */
export const TREASURY_WALLET_ANALYTICS_NAV = {
  id: 'treasury-wallet-analytics',
  section: 's-3.2.2',
  fsd: '3.2.2.10',
  code: 'R042',
  to: '/treasury/reports/wallet-analytics',
  labelKey: 'treasury.walletAnalytics.nav.label',
  descriptionKey: 'treasury.walletAnalytics.nav.description',
  permission: WALLET_ANALYTICS_PERMISSIONS.read,
} as const

export const TREASURY_WALLET_ANALYTICS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/treasury/reports/wallet-analytics',
    name: 'treasury-wallet-analytics',
    component: () => import('@/modules/treasury/reports/wallet-analytics/WalletAnalyticsView.vue'),
    meta: {
      titleKey: 'treasury.walletAnalytics.routeTitle',
      permission: WALLET_ANALYTICS_PERMISSIONS.read,
    },
  },
]
